import Pills from './pills';

export default Pills;
